export default __webpack_public_path__ + "static/media/Reply.2290e480.svg";